const COOKIE_NAME = 'mep_consent';
const COOKIE_MAX_AGE_SECONDS = 180 * 24 * 60 * 60; // ~6 months

type ConsentCategory = 'analytics';

type ConsentCookie = {
  categories: Record<ConsentCategory, boolean>;
  version: string;
  timestamp: string;
};

export function getConsentCookie(): ConsentCookie | null {
  const cookie = document.cookie
    .split(';')
    .find((item) => item.trim().startsWith(`${COOKIE_NAME}=`));

  if (!cookie) return null;

  try {
    const value = decodeURIComponent(
      cookie.split('=').slice(1).join('=').trim()
    );
    return JSON.parse(value) as ConsentCookie;
  } catch {
    return null;
  }
}

export function setConsent(
  category: ConsentCategory,
  consented: boolean
): void {
  const existing = getConsentCookie();
  const consent: ConsentCookie = {
    categories: {
      ...existing?.categories,
      [category]: consented,
    },
    version: import.meta.env.VITE_APP_VERSION ?? 'unknown',
    timestamp: new Date().toISOString(),
  };

  const value = encodeURIComponent(JSON.stringify(consent));
  document.cookie = `${COOKIE_NAME}=${value}; max-age=${COOKIE_MAX_AGE_SECONDS}; path=/; SameSite=Lax; Secure`;
}

export function hasConsent(category: ConsentCategory): boolean {
  const consent = getConsentCookie();
  return consent?.categories[category] === true;
}

export function hasDeclined(category: ConsentCategory): boolean {
  const consent = getConsentCookie();
  return consent?.categories[category] === false;
}

export function hasRespondedToConsent(): boolean {
  return getConsentCookie() !== null;
}

export function clearConsent(): void {
  document.cookie = `${COOKIE_NAME}=; max-age=0; path=/; SameSite=Lax; Secure`;
}
